<template>
	<li>
		<a :href="`/careers/openings/${ posting.slug }/`">
			<div class="level">
				<div class="level-left">
					<div>
						<h3 class="title is-4 mb-1">{{ posting.title }}</h3>
						<h4 class="subtitle is-6 mt-0 has-text-blue">
							{{ posting.workplaceType }} &middot;
							{{ posting.commitment }} &middot;
							{{ posting.locationLabel }}
						</h4>
					</div>
				</div>
				<div class="level-right is-hidden-mobile">
					<span class="button">Apply now</span>
				</div>
			</div>
		</a>
	</li>
</template>

<script>

export default {
	props: {
		posting: {
			type: Object,
			required: true,
		},
	},
};

</script>
